import { TranslatedText } from "@/components/common/text";

export const Paragraph = ({ children }) => {
  return (
    <p className="text-base/[25px] text-cm-p-text-primary mb-6">
      <TranslatedText>{children}</TranslatedText>
    </p>
  );
};
